module.exports = __webpack_public_path__ + "static/media/git_icon_store.11647cda.png";